<template>
	<div class="form-group group-radio-shapes">
		<label :for="name">{{ placeholder }}</label>
		<div class="items">
			<label v-for="option in options" :key="option.value" class="item">
				<input type="radio" :name="name" :id="option.text" :value="option.value" v-model="selected" @change="onChange" v-validate="rules" :data-vv-as="placeholder">
				<shape :src="svgSrc(option.text)" class="pill-svg" :class="cssClass(option.value)"/>
			</label>
		</div>
		<span v-if="rules" v-show="errors.has(name)" class="text-danger">{{ errors.first(name) }}</span>
	</div>
</template>

<script>
export default {
	inject: ['$validator'],
	props: [
		'value',
		'color',
		'name',
		'placeholder',
		'rules'
	],
	data () {
		return {
			options: [
				{ value: 1, text: 'shape01' },
				{ value: 2, text: 'shape02' },
				{ value: 3, text: 'shape03' },
				{ value: 4, text: 'shape04' },
				{ value: 5, text: 'shape05' },
				{ value: 6, text: 'shape06' },
				{ value: 7, text: 'shape07' },
				//{ value: 8, text: 'shape08' }
			],
			selected: ''
		}
	},
	watch: {
		value () {
			this.selected = this.value
		}
	},
	computed: {
		result () {
			return this.selected ? this.selected : 0
		}
	},
	methods: {
		svgSrc (shape) {
			return `/static/svg/pills/${shape}.svg`
		},
		cssClass (option) {
			let classes = []
			if (option === this.selected) {
				if (this.color) {
					classes.push(`color-${this.color}`)
				}
				classes.push('selected')
			}
			return classes.join(' ')
		},
		onChange () {
			this.$emit('input', this.result)
		}
	},
	created () {
		this.$nextTick(function () {
			this.options.forEach(element => {
				if (element.value === parseInt(this.value)) {
					this.selected = element.value
				}
			})
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/pillboxV2/InputShape.vue